import React, { PropsWithChildren } from 'react';

type CommonProps = {
  variant?: 'primary' | 'secondary' | 'negative';
  isLoading?: boolean;
  size?: 'normal' | 'small';
  showSuccess?: boolean;
  successText?: string;
};

export type RegularButtonProps = CommonProps & React.ButtonHTMLAttributes<HTMLButtonElement>;
export type LinkButtonProps = CommonProps &
  React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    isExternal?: boolean;
  };

export type ButtonProps = RegularButtonProps | LinkButtonProps;

export const isLinkButton = (props: RegularButtonProps | LinkButtonProps): props is LinkButtonProps => 'href' in props;

export type ButtonGroupProps = PropsWithChildren<{
  alignment?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'start'
    | 'end'
    | 'left'
    | 'right';
  className?: string;
}>;
